// extracted by css-extract-rspack-plugin
export default {"groupDescription":"Vx2z5"};